import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export const useGetNearLesson = (teamId?: string, disabled?: boolean) =>  {
        const [resp, setResp] = useState<any>(undefined);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const { i18n: { language }} = useTranslation();

        useEffect(() => {

            if (disabled) return;

                setIsLoading(true)
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url('/api/LMS/GetNearLesson')
                    .get()
                    .addQuery('teamId', teamId || '')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        if (r?.lessonInfo) setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
        }, [disabled, teamId])

    return {lesson: API.toLang(resp, language) as any, isLoading, error};
    }import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export const useGetNearLesson = (teamId?: string, disabled?: boolean) =>  {
        const [resp, setResp] = useState<any>(undefined);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const { i18n: { language }} = useTranslation();

        useEffect(() => {

            if (disabled) return;

                setIsLoading(true)
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url('/api/LMS/GetNearLesson')
                    .get()
                    .addQuery('teamId', teamId || '')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        if (r?.lessonInfo) setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
        }, [disabled, teamId])

    return {lesson: API.toLang(resp, language) as any, isLoading, error};
    }